__turbopack_context__.v({
  "close": "CardDetailsModal-module-scss-module__7PK82W__close",
  "listDescription": "CardDetailsModal-module-scss-module__7PK82W__listDescription",
  "listTitle": "CardDetailsModal-module-scss-module__7PK82W__listTitle",
  "title": "CardDetailsModal-module-scss-module__7PK82W__title",
});
